import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lendingConfig } from '../../../environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-lending-bawag',
    template: ''
})
export class LendingComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = params['inApp'];
      if (inApp) {
        lendingConfig.redirectUri = lendingConfig.redirectUri + '?inApp=true';
      }
    });
  }

  ngOnInit(): void {
    this.loginService.login(lendingConfig);
  }
}
